export default __webpack_public_path__ + "static/media/blog-img78.c9ba2596.jpg";